import React from 'react';
import { createGlobalStyle } from 'styled-components'
import { render } from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import * as qs from 'query-string';

import ApolloClient from './ApolloClient'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';

// Layouts
import LayoutLogin from './layouts/Login';
import LayoutDefault from './layouts/Default';
import LayoutNone from './layouts/None';

// Páginas

import PaginaLogin from './pages/Login';
import PaginaPuntos from './pages/Puntos';
import PaginaReestablecerContrasena from './pages/ReestablecerContrasena';
import PaginaReestablecerContrasenaToken from './pages/ReestablecerContrasenaToken';
import PaginaReenvioConfirmacion from './pages/ReenvioConfirmacion';
import PaginaContenidos from './pages/Contenidos';
import ContenidoBeneficios from './pages/ContenidoBeneficios';
import PaginaEventos from './pages/Eventos';
import PaginaRegistroAcreditación from './pages/RegistroAcreditacion';
import PaginaInicio from './pages/Inicio';
import PaginaCuenta from './pages/Cuenta';
import PaginaAtencionPersonal from './pages/AtencionPersonal';
import PaginaAbonos from './pages/Abonos';
import PaginaGuiaGastronomica from './pages/GuiaGastronomica';
import PaginaCuentaEdit from './pages/CuentaEdit';
import EventoRegistro from './pages/EventoRegistro';
import PaginaSolicitudConfirmacion from './pages/SolicitudConfirmacion';
import PageCrearAcreditacion from './pages/CrearAcreditacion';
import PaginaDemo from './pages/PaginaDemo';
import TestQr from './pages/TestQr';
import PaginaQRGuiaGastronomica from './pages/QRGuiaGastronomica';
import Validacion from './pages/Validacion';
import Puntos from './pages/Puntos';
import PaginaRuboAlAtras from './pages/RuboAlAstras';
import PaginaDialyPromo from './pages/DialyPromo';
import PagNotificaciones from './pages/Notificaciones';
import PagDescuentos from './pages/Descuentos';


//Models
import AcreditacionProfile from './models/AcreditacionProfile';

const GlobalStyle = createGlobalStyle`
  .grecaptcha-badge {display: none !important;}
`;

const PrivateRoute=({ children, ...rest }) => {
    const queryParams = qs.parse(window.location.search);

    return (
        <Route {...rest} render={({ location }) =>
            (AcreditacionProfile.isLoginIn({token:queryParams?.token}))? 
                children
                : 
                <Redirect to={{ pathname: '/login', state: { from: location }}} />
        }
        />
    );
}

const App = () => { 
    let UserInfo=AcreditacionProfile.getProfile();

    return (
        <ApolloProvider client={ApolloClient}> 
            <Router>
                <GlobalStyle />
                <Switch>
                    <Route path="/" exact><Redirect to="/inicio"></Redirect></Route>
                    <LayoutDefault title="Iniciar sesión" path="/login" exact component={PaginaLogin} />
                    <LayoutDefault title="Reestablecer contraseña" path="/reestablecer-contrasena" exact component={PaginaReestablecerContrasena} />
                    <LayoutDefault title="Reestablecer contraseña" path="/reestablecer-contrasena/uuid/:uuid" exact component={PaginaReestablecerContrasenaToken} />

                    <LayoutDefault title="Crear nuevo Atleti Id" path="/registro-atleti-id" exact component={PageCrearAcreditacion} />
                    <LayoutDefault title="Registro de Atleti Id" path="/registro-atleti-id/uuid/:uuid" component={PaginaRegistroAcreditación} />

                    <LayoutDefault title="Página demo" path="/demo" component={PaginaDemo} />
                    <LayoutDefault title="Página demo" path="/demo" component={PaginaDemo} />
                    <LayoutDefault title="Test" path="/testQR" component={TestQr} />

                    <LayoutNone title="Validation" path="/validation" component={Validacion} />
                    <LayoutNone title="Validation" path="/qr_guia_gastronomica" component={PaginaQRGuiaGastronomica} />

                    <PrivateRoute>
                        <LayoutDefault title="Puntos" path="/puntos" exact component={PaginaPuntos} />

                        <LayoutDefault title="Rumbo al Lastras" path="/rumbo-al-lastras" exact className="ruboalastras"  component={PaginaRuboAlAtras} />
                        <LayoutDefault title="Rumbo al Lastras" path="/rumbo-al-lastras-movil" exact className="ruboalastras" menu={false} component={PaginaRuboAlAtras} />
                    
                        <LayoutDefault title="Inicio" path="/inicio" exact component={PaginaInicio} />
                        <LayoutDefault title="Eventos" path="/eventos" exact component={PaginaEventos} />
                        <LayoutDefault title="Registro del evento" path="/evento/registro/:event_uuid" component={EventoRegistro} />

                        <LayoutDefault title="Contenidos" path="/beneficios/abonos" component={ContenidoBeneficios} />
                        <LayoutDefault title="Guía Gastronómica" path="/guia_gastronomica" component={PaginaGuiaGastronomica} />
                        <LayoutDefault title="Contenidos" path="/contenidos/:url" component={PaginaContenidos} />
                        <LayoutDefault title="Mi cuenta" path="/micuenta" exact component={PaginaCuenta} />
                        <LayoutDefault title="Atención personal" path="/antecion-personal" exact component={PaginaAtencionPersonal} />
                        <LayoutDefault title="Mis Abonos" path="/abonos" exact component={PaginaAbonos} />
                        <LayoutDefault title="Edita cuenta" path="/micuenta-edit" exact component={PaginaCuentaEdit} />
                        <LayoutDefault title="Confirmación" path="/solicitud-confirmacion" exact component={PaginaSolicitudConfirmacion} />
                        <LayoutDefault title="Portal de Abonado ADSL" path="/dayPromo" exact component={PaginaDialyPromo} />
                        <LayoutDefault title="Notificaciones" path="/notificaciones" exact component={PagNotificaciones} />
                        <LayoutDefault title="Descuentos" path="/descuentos" exact component={PagDescuentos} />
                    </PrivateRoute>
                </Switch>
            </Router>
        </ApolloProvider>
    );
}

const root = document.getElementById('App');
render(<App />, root);
